<script>
import { defineComponent, ref } from 'vue'
export default defineComponent({
  name: 'ThePreloader',
  setup () {
    return {
      visible: ref(true),
      noBg: ref(false)
    }
  }
})
</script>

<template>
  <div id="app-loading-container">
    <transition>
      <div v-if="visible" id="app-loading" :class="{'no-bg': noBg, 'dark-bg': !noBg}">
        <div class="spinner-container" :class="{'scaling': noBg }">
          <svg class="svg-border" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><path fill-rule="evenodd" clip-rule="evenodd" d="M64 128c35.346 0 64-28.654 64-64 0-35.346-28.654-64-64-64C28.654 0 0 28.654 0 64c0 35.346 28.654 64 64 64ZM66.862 6.112a4.82 4.82 0 0 0-5.724 0 4.82 4.82 0 0 1-4.962.46 4.82 4.82 0 0 0-5.626 1.051 4.82 4.82 0 0 1-4.793 1.364 4.82 4.82 0 0 0-5.337 2.068 4.82 4.82 0 0 1-4.461 2.221 4.82 4.82 0 0 0-4.866 3.013 4.82 4.82 0 0 1-3.977 3.003 4.82 4.82 0 0 0-4.23 3.856 4.819 4.819 0 0 1-3.357 3.683 4.82 4.82 0 0 0-3.45 4.567 4.819 4.819 0 0 1-2.623 4.237 4.82 4.82 0 0 0-2.55 5.124 4.82 4.82 0 0 1-1.801 4.647 4.82 4.82 0 0 0-1.566 5.505 4.82 4.82 0 0 1-.916 4.898 4.82 4.82 0 0 0-.528 5.7 4.82 4.82 0 0 1 0 4.983 4.82 4.82 0 0 0 .528 5.698 4.82 4.82 0 0 1 .916 4.9 4.82 4.82 0 0 0 1.566 5.504 4.82 4.82 0 0 1 1.8 4.647 4.82 4.82 0 0 0 2.551 5.123 4.819 4.819 0 0 1 2.624 4.237 4.82 4.82 0 0 0 3.449 4.568 4.82 4.82 0 0 1 3.357 3.683 4.818 4.818 0 0 0 4.23 3.855 4.82 4.82 0 0 1 3.977 3.004 4.82 4.82 0 0 0 4.866 3.013 4.817 4.817 0 0 1 4.46 2.221 4.818 4.818 0 0 0 5.338 2.067 4.822 4.822 0 0 1 4.793 1.364 4.818 4.818 0 0 0 5.626 1.052 4.82 4.82 0 0 1 4.962.46 4.82 4.82 0 0 0 5.724 0 4.82 4.82 0 0 1 4.962-.46 4.818 4.818 0 0 0 5.626-1.052 4.822 4.822 0 0 1 4.793-1.364 4.818 4.818 0 0 0 5.337-2.067 4.817 4.817 0 0 1 4.46-2.221 4.82 4.82 0 0 0 4.867-3.013 4.82 4.82 0 0 1 3.977-3.004 4.82 4.82 0 0 0 4.23-3.855 4.82 4.82 0 0 1 3.357-3.683 4.82 4.82 0 0 0 3.449-4.568 4.82 4.82 0 0 1 2.623-4.237 4.82 4.82 0 0 0 2.552-5.123 4.817 4.817 0 0 1 1.8-4.647 4.82 4.82 0 0 0 1.566-5.505 4.818 4.818 0 0 1 .916-4.898 4.82 4.82 0 0 0 .528-5.7 4.817 4.817 0 0 1 0-4.983 4.82 4.82 0 0 0-.528-5.699 4.818 4.818 0 0 1-.916-4.898 4.82 4.82 0 0 0-1.566-5.505 4.817 4.817 0 0 1-1.8-4.647 4.82 4.82 0 0 0-2.552-5.124 4.82 4.82 0 0 1-2.623-4.237 4.819 4.819 0 0 0-3.449-4.567 4.819 4.819 0 0 1-3.357-3.683 4.82 4.82 0 0 0-4.23-3.856 4.82 4.82 0 0 1-3.977-3.003 4.82 4.82 0 0 0-4.866-3.013 4.82 4.82 0 0 1-4.461-2.221 4.82 4.82 0 0 0-5.337-2.068 4.82 4.82 0 0 1-4.793-1.364 4.82 4.82 0 0 0-5.626-1.051 4.82 4.82 0 0 1-4.962-.46Z" fill="#D4C5BB" /></svg>
          <svg class="spinner" viewBox="0 0 49 49">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="1"></circle>
          </svg>
          <svg class="spinner-back" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="1"></circle>
          </svg>
          <svg class="logo" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78 24"><path d="M8.086.6H.022V23h8.064v-1.44H3.734v-8.928h4.352v-1.856H3.734v-8.64h4.352V.6Zm9.162 11.456L21.632.6h-1.408l-3.712 9.568L12.736.6h-3.68l4.448 11.072L9.056 23h1.408l3.776-9.472L18.08 23h3.552l-4.384-10.944Zm16.767-1.664V2.68C32.383.76 28.735.6 28.735.6h-5.088V23h3.744V12.696s4.096.224 6.624-2.304Zm-6.624.48V2.168s1.568-.16 2.816.736v7.008s-.704.96-2.816.96ZM41.298.376c-2.24 0-5.184 1.376-5.184 1.376v19.936s2.816 1.536 5.088 1.536c2.24 0 5.216-1.408 5.216-1.408V1.912S43.57.376 41.298.376Zm-1.44 21.28V2.008s1.184-.96 2.816-.096V21.56s-1.184.96-2.816.096ZM58.013 7.608V2.136h6.528V.632H54.365v11.552h3.68V9.08s1.152-.96 2.784-.096v12.608s-1.152.96-2.784.128v-6.368h-3.68v6.368s2.816 1.504 5.024 1.504c2.24 0 5.152-1.344 5.152-1.344V8.952s-2.816-1.504-5.024-1.504c-.512 0-.992.064-1.504.16ZM74.238.344a6.423 6.423 0 0 0-1.344-.16h-.096c-.48 0-.928.064-1.376.16-1.28.256-2.56.672-3.744 1.216v8.736s1.568 1.472 3.232 1.472c-1.888 0-3.232 1.504-3.232 1.504v8.576c1.184.544 2.464.96 3.744 1.216.448.096.896.16 1.376.16h.096c.448 0 .896-.064 1.344-.16a16.537 16.537 0 0 0 3.744-1.216v-8.576s-1.344-1.504-3.232-1.504c1.664 0 3.232-1.472 3.232-1.472V1.56A16.537 16.537 0 0 0 74.238.344ZM71.422 21.56v-8.224s.416-.288 1.408-.448c1.024.16 1.408.448 1.408.448v8.224a2.402 2.402 0 0 1-2.816 0Zm0-11.328V1.848a2.305 2.305 0 0 1 2.816 0v8.384s-.384.288-1.408.448c-.992-.16-1.408-.448-1.408-.448Z" fill="#E0BF4F" /></svg>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss">
#app-loading {
  position: absolute;
  z-index: 99999;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dark-bg {
  background-color: #0e0f11;
}

.no-bg {
  background: transparent;
}

.scaling {
  scale: 0.8;
}

.spinner-container {
  position: absolute;
  width: 124px;
  height: 124px;
  border-width: 0;
  border-style: solid;
  border-color: #d4c5bb80;
  border-radius: 99999px;

  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 124px;
    height: 124px;
    border-width: 1px;
    border-style: solid;
    border-color: #d4c5bb20;
    border-radius: 99999px;
    content: "";
    transform: translate(-50%, -50%);
  }
}

.spinner,
.svg-border,
.logo,
.spinner-back {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.svg-border {
  width: 96px;
  height: 96px;
}

.spinner,
.spinner-back {
  width: 137px;
  height: 137px;
  rotate: -90deg;
  transform-origin: left top;

  .path {
    stroke-linecap: round;
  }
}

.spinner {
  // animation: rotate 2s linear infinite;
  transform: translate(-51%, -51%);

  .path {
    animation: dash 1s linear infinite;
    stroke: #e0bf4f;
  }
}

.spinner-back {
  .path {
    stroke: #d4c5bb50;
  }
}

.logo {
  width: 62px;
  height: 24px;
}

// @keyframes rotate {
//   100% {
//     rotate: 360deg;
//   }
// }

@keyframes dash {
  0% {
    stroke-dasharray: 32, 92;
    stroke-dashoffset: 100;
  }

  50% {
    stroke-dasharray: 32, 92;
    stroke-dashoffset: 50;
  }

  100% {
    stroke-dasharray: 32, 92;
    stroke-dashoffset: -25;
  }
}

</style>
